const API = process.env.REACT_APP_BACKEND_URL;

const send = (page, event) => {
  try {
    fetch(`${API}/api/track/page`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page, event }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) { /* ignore */ }
};

export const trackPageView = (page) => send(page, 'view');
export const trackDownloadClick = (page) => send(page, 'download_click');
